import React, { useContext, useEffect, useState } from 'react'
import './NavBar.css'
import { ExamData, ExamDetails } from '../view/Private/Exam/context';
import { Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faInfoCircle, faSquarePlus, faSquareMinus, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EndExamConfirmation from './Modal/EndExamConfirmation';
import LiveExam from '../Services/liveexam.services';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import InfoMadal from './Modal/InfoMadal';
import { useInterval } from 'usehooks-ts'
import { zoomIn, zoomOut } from '../helpers/zoominout';
import UserInfoModal from './Modal/UserInfoModal';

export default function NavBar() {
    const [showModal, setShowModal] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [seconds, setSeconds] = useState(9999);
    const [elapsed, setElapsed] = useState(0);
    const [userInfo, setUserInfo] = useState<any>({ student: { image: "", name: "", first_name: "" } });

    const examDetails: any = useContext(ExamDetails);
    const navigate = useNavigate();

    useEffect(() => {
        const t = setInterval(() => {
            setSeconds(s => {
                if (s <= 1) { handleExamSubmission(); return 0; }
                return s - 1;
            });
            setElapsed(e => e + 1);
        }, 1000);
        return () => clearInterval(t);
    }, []);

    useInterval(() => { getUserExamLeftTime(); }, 10000);

    const getUserInfo = async () => {
        await LiveExam.getUserInfo().then(res => {
            if (res.status === 200) {
                setUserInfo(res.data.data);
                setSeconds(res.data.data.remainingTime);
            }
        });
    };

    const handleExamSubmission = async () => {
        await LiveExam.setExamStatusCompleted().then(res => {
            if (res.status === 200) {
                toast.success("Exam Submitted");
                localStorage.removeItem("authKey");
                localStorage.removeItem("liveToken");
                navigate("/exam_submitted");
            }
        }).catch(console.error);
    };

    const getUserExamLeftTime = async () => {
        await LiveExam.checkUserRemainingTime(seconds).then(res => {
            if (res.status === 200) {
                if (res.data.data.update_required) setSeconds(res.data.data.user_time);
                if (res.data.data.blocked) {
                    toast.error("You have been blocked. Contact admin.");
                    sessionStorage.removeItem("liveToken");
                    localStorage.removeItem("authKey");
                    navigate("/authentication");
                }
            }
        }).catch((e: any) => {
            if (e.response?.status === 410) {
                toast.error("You have been blocked. Contact admin.");
                sessionStorage.removeItem("liveToken");
                localStorage.removeItem("authKey");
                navigate("/authentication");
            }
        });
    };

    useEffect(() => { getUserInfo(); }, []);

    const eHrs = Math.floor(elapsed / 3600);
    const eMinsFinal = Math.floor((elapsed % 3600) / 60);
    const eSecs = elapsed % 60;

    return (
        <>
            <div className="xen-top-nav noselect">
                {/* Left: client icon + info */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: '0 0 auto' }}>
                    {examDetails?.examDetail?.icon && (
                        <img className="dcm-client-icon" src={examDetails.examDetail.icon} alt="exam icon" />
                    )}
                    <FontAwesomeIcon
                        icon={faInfoCircle}
                        onClick={() => setShowInfoModal(true)}
                        style={{ color: '#9CA3AF', cursor: 'pointer', fontSize: 15 }}
                    />
                </div>

                {/* Centre: exam name + timer */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ fontWeight: 700, fontSize: '0.875rem', color: '#1A1A2E', lineHeight: 1.25 }}>
                        {examDetails?.examDetail?.examName || 'Loading\u2026'}
                    </span>
                    <span style={{ fontSize: '0.72rem', fontWeight: 600, color: '#6C757D', lineHeight: 1.25 }}>
                        {eHrs > 0 ? `${eHrs}h ` : ''}{eMinsFinal}m {eSecs < 10 ? '0' : ''}{eSecs}s
                    </span>
                </div>

                {/* Right: zoom + avatar + submit */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: '0 0 auto' }}>
                    <span style={{ fontSize: '0.8rem', color: '#6C757D', display: 'flex', alignItems: 'center', gap: 5 }}>
                        <FontAwesomeIcon icon={faSquareMinus} onClick={zoomOut} style={{ cursor: 'pointer' }} />
                        A
                        <FontAwesomeIcon icon={faSquarePlus} onClick={zoomIn} style={{ cursor: 'pointer' }} />
                    </span>

                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="user-tooltip"><UserInfoModal /></Tooltip>}
                    >
                        {({ ref, ...triggerHandler }) => (
                            <Image
                                src={userInfo?.student?.image}
                                ref={ref as any}
                                {...triggerHandler}
                                roundedCircle
                                style={{ height: 34, width: 34, objectFit: 'cover', cursor: 'pointer', border: '2px solid #EDE9FF' }}
                            />
                        )}
                    </OverlayTrigger>

                    <Button
                        size="sm"
                        onClick={() => setShowModal(true)}
                        style={{ background: '#EF4444', border: 'none', fontWeight: 600, fontSize: '0.75rem', borderRadius: 7, padding: '5px 12px', whiteSpace: 'nowrap' }}
                    >
                        <FontAwesomeIcon icon={faTriangleExclamation} className="me-1" />
                        Submit &amp; End Exam
                    </Button>
                </div>
            </div>

            <EndExamConfirmation show={showModal} setShow={setShowModal} onSuccess={handleExamSubmission} />
            <InfoMadal show={showInfoModal} setShow={setShowInfoModal} />
        </>
    );
}
